/**
 * Catálogo de la documentación (carpeta docs/ del repositorio) incluida en la web al compilar.
 *
 * Vite convierte cada .md en un módulo de carga perezosa: el texto solo se descarga al abrir ese
 * documento. No hay endpoint en la API ni dependencias nuevas (ver ADR-0011).
 */
const cargadores = import.meta.glob('../../../../../docs/**/*.md', {
  query: '?raw',
  import: 'default',
}) as Record<string, () => Promise<string>>;

export interface DocumentoDoc {
  /** Ruta relativa a docs/, p. ej. `arquitectura/web.md`. */
  ruta: string;
  etiqueta: string;
  grupo: string;
  cargar: () => Promise<string>;
}

export const DOCUMENTO_INICIAL = 'README.md';

const NOMBRE_GRUPO: Record<string, string> = {
  '': 'General',
  arquitectura: 'Arquitectura',
  guias: 'Guías',
  api: 'API',
  decisiones: 'Decisiones (ADR)',
};
const ORDEN_GRUPOS = Object.keys(NOMBRE_GRUPO);

const mayuscula = (t: string) => t.charAt(0).toUpperCase() + t.slice(1);

export function etiquetaDeArchivo(ruta: string): string {
  const archivo = ruta.split('/').pop() ?? ruta;
  const base = archivo.replace(/\.md$/i, '');
  if (base === 'README') return 'Índice';
  const adr = /^(ADR-\d+)-(.+)$/.exec(base);
  if (adr) return `${adr[1]}: ${(adr[2] ?? '').replace(/-/g, ' ')}`;
  return mayuscula(base.replace(/-/g, ' '));
}

export function construirCatalogo(
  origen: Record<string, () => Promise<string>> = cargadores,
): DocumentoDoc[] {
  const docs = Object.entries(origen).map(([clave, cargar]) => {
    const ruta = clave.slice(clave.indexOf('/docs/') + '/docs/'.length);
    const carpeta = ruta.includes('/') ? ruta.slice(0, ruta.indexOf('/')) : '';
    return {
      ruta,
      etiqueta: etiquetaDeArchivo(ruta),
      grupo: NOMBRE_GRUPO[carpeta] ?? mayuscula(carpeta),
      cargar,
    };
  });
  const posicion = (d: DocumentoDoc) => {
    const i = ORDEN_GRUPOS.findIndex((g) => NOMBRE_GRUPO[g] === d.grupo);
    return i === -1 ? ORDEN_GRUPOS.length : i;
  };
  return docs.sort(
    (a, b) =>
      posicion(a) - posicion(b) ||
      (a.ruta === DOCUMENTO_INICIAL ? -1 : b.ruta === DOCUMENTO_INICIAL ? 1 : 0) ||
      a.ruta.localeCompare(b.ruta),
  );
}

export const CATALOGO = construirCatalogo();
